/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span[_ngcontent-%COMP%]{color:#585f6c;font-size:12px}.errorBar[_ngcontent-%COMP%]{background-color:#eceeef;padding:5px;line-height:1rem;border-radius:5px}.form-modal[_ngcontent-%COMP%]{margin-top:25px}"];
export { styles as styles };
